import React from "react";
import sImage1 from '../../Assets/Project3/secondaryPart/secondary research 1.webp';
import sImage2 from '../../Assets/Project3/secondaryPart/secondary research 2.webp';
import sImage3 from '../../Assets/Project3/secondaryPart/secondary research 3.webp';
import sImage4 from '../../Assets/Project3/secondaryPart/secondary reserach 4.webp';
import sImage5 from '../../Assets/Project3/secondaryPart/secondary reserach 5.webp';
import sImage6 from '../../Assets/Project3/secondaryPart/secondary reserach 6.webp';
import sImage7 from '../../Assets/Project3/secondaryPart/secondary research 7.webp';

const SecondaryPart = () => {
    return (
        <div className="secondaryPart-container">
            <h1>Secondary Research</h1>

            <div className="secondary-images-grid">
                <img src={sImage1} className="secondary-grid-image" />
                <img src={sImage2} className="secondary-grid-image" />
                <img src={sImage3} className="secondary-grid-image" />
                <img src={sImage4} className="secondary-grid-image" />
                <img src={sImage5} className="secondary-grid-image" />
                <img src={sImage6} className="secondary-grid-image" />
                <img src={sImage7} className="secondary-grid-image" />
            </div>
        </div>
    );
};

export default SecondaryPart;